export { default } from './ProductExtraSale'



// WEBPACK FOOTER //
// ./src/App/components/ProductExtraSale/index.js